import { Component, h } from 'preact'
import ProductUpdateView from './ProductUpdateView'
import { ProductUpdateType } from './Types'
import Phrase from '../../libs/translationsUtils/phrase'
import Button from '../ui-components/Button'
import axios from 'axios'

interface Props {
  isGuest: boolean,
  productUpdates: Array<ProductUpdateType>
}


interface ButtonProps {
  isGuest: boolean
}

interface ButtonState {
  isSubscribed: boolean
  isLoading: boolean
}

class SubscribeButton extends Component<ButtonProps, ButtonState> {
  constructor() {
    super()
    this.state = {
      isSubscribed: false,
      isLoading: false
    }
    this.toggleSubscription = this.toggleSubscription.bind(this)
  }
  async componentDidMount() {
    const result = await axios.get('/product-updates/subscription')
    const isSubscribed = result.data
    this.setState({isSubscribed})
  }

  async toggleSubscription () {
    this.setState({isLoading: true})
    const isSubscribed = this.state.isSubscribed
    const url = isSubscribed
      ? '/product-updates/unsubscribe'
      : '/product-updates/subscribe'
    try {
      await axios.post(url)
      this.setState({isSubscribed: !isSubscribed})
    } finally {
      this.setState({isLoading: false})
    }
  }

  render (props: ButtonProps, state: ButtonState) {
    if (props.isGuest) {
      return <Button toggle disabled>Subscribe</Button>
    }

    return <Button disabled={state.isLoading} toggle toggleActive={state.isSubscribed} onClick={this.toggleSubscription}>
      {state.isSubscribed ? 'Unsubscribe' : 'Subscribe'}
    </Button>
  }
}

class ProductUpdatesOverview extends Component<Props> {
  render ({ isGuest, productUpdates }: Props) {
    return (
      <div className='product-updates-overview-wrapper'>
        <div className='sitewidth text-center'>
          <h1 className='product-updates-overview-wrapper-title'><Phrase p='product.updates.overview.title' /></h1>
          <br/>
          <SubscribeButton isGuest={isGuest}>Subscribe</SubscribeButton>
        </div>
        <div className='product-updates-overview'>
          {
            productUpdates.map(productUpdate => <ProductUpdateView {...productUpdate} isGuest={isGuest} />)
          }
        </div>
      </div>
    )
  }
}

export default ProductUpdatesOverview
